import {yupResolver} from '@hookform/resolvers/yup';
import React, {useMemo, useState} from 'react';
import {useForm} from 'react-hook-form';
import * as yup from 'yup';

import toast from 'react-hot-toast';
import {
  useAddSubjectMutation,
  useUpdateSubjectMutation,
} from '../../api/candidateTest';
import {invalidateQueryV2} from '../../services/reactQuery/index';
import {compilerOptions} from '../../utils/constants';
import Modal from '../common/Modal';
import FormItem from '../jobForm/FormItem';
import Button from '../ui/Button';
import InputField from '../ui/InputField';
import {SelectFieldHookForm} from '../ui/SelectField';

const subjectSchema = yup.object().shape({
  skill: yup.string().required('skill is required'),
  testQuestionCount: yup
    .number()
    .typeError('total test Questions count is required')
    .positive('Enter positive number'),
  testTime: yup
    .number()
    .typeError('Test time is required')
    .positive('Enter positive number'),
  compiler: yup.object().nullable().required('compiler is required'),
});

const AddSubjectModal = ({
  subjectDetails = null,
  editMode = false,
  onSuccess = () => {},
  ...props
}) => {
  const {mutate: addSubjectMutation, isLoading: isAddSubjectLoading} =
    useAddSubjectMutation();
  const {mutate: updateSubjectMutation, isLoading: isUpdateSubjectLoading} =
    useUpdateSubjectMutation();

  const [selectedCompiler, setSelectedCompiler] = useState([]);
  const [isValidCompiler, setIsValidCompiler] = useState(true);

  const defaultFormValues = useMemo(() => {
    if (editMode) {
      const {testQuestionCount, testTime, subject} = subjectDetails;
      return {
        skill: subject,
        testQuestionCount,
        testTime,
      };
    }
    return {};
  }, [editMode, subjectDetails]);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(subjectSchema),
    mode: 'all',
    defaultValues: defaultFormValues,
  });

  const onSubjectSuccess = () => {
    toast.success(`Subject ${editMode ? 'updated' : 'added'} Successfully`);
    reset();
    props.onClose();
    props.refetch();
    invalidateQueryV2(['subjectList']);

    onSuccess();
  };

  const handleFormSubmission = (values) => {
    // if (isEmpty(selectedCompiler)) {
    //   setIsValidCompiler(false);
    // } else {
    console.log('values', values);
    const {skill, testQuestionCount, testTime, compiler} = values;

    let payload = {
      skill: skill,
      testQuestionCount: +testQuestionCount,
      testTime: +testTime,
      compiler: compiler,
    };

    const mutationOptions = {
      onSuccess: onSubjectSuccess,
      onError: (data) => toast.error(data.response.data.message),
    };

    if (editMode) {
      payload = {
        testTime: payload.testTime,
        testQuestionCount: payload.testQuestionCount,
        compiler: compiler,
        subjectId: subjectDetails._id,
      };
      updateSubjectMutation(payload, mutationOptions);
    } else {
      addSubjectMutation(payload, mutationOptions);
    }
    // }
  };

  return (
    <Modal {...props} containerClassName="max-w-[600px]">
      <form className="mt-3 px-2" onSubmit={handleSubmit(handleFormSubmission)}>
        <div className="bg-white flex flex-col gap-6">
          <div className="flex flex-col gap-5">
            <div className="flex flex-col">
              <label className="font-semibold mb-2.5">Skill</label>
              <InputField
                name="skill"
                {...register('skill')}
                placeholder="Enter skill"
                error={errors.skill?.message}
                disabled={editMode}
              />
            </div>
            {/* <FormItem label="Compiler" htmlFor="compiler">
              <Select
                // isMulti
                options={compilerOptions}
                className="basic-multi-select text-[18px] "
                onChange={(e) => {
                  if (e.length > 0) {
                    setIsValidCompiler(true);
                  } else {
                    setIsValidCompiler(false);
                  }
                  setSelectedCompiler(e);
                }}
              />
              {!isValidCompiler && (
                <div className="text-error text-sm pt-1">select compiler</div>
              )}
            </FormItem> */}

            <FormItem label="Compiler" htmlFor="compiler">
              <SelectFieldHookForm
                placeholder="selelct compiler"
                id="compiler"
                name="compiler"
                className="w-full bg-white"
                control={control}
                options={compilerOptions}
                error={errors?.compiler?.message}
              />
            </FormItem>

            <div className="flex flex-col">
              <label className="font-semibold mb-2.5">
                Test Questions Count
              </label>
              <InputField
                name="testQuestionCount"
                {...register('testQuestionCount')}
                type="number"
                placeholder="Enter Test question count"
                error={errors.testQuestionCount?.message}
              />
            </div>

            <div className="flex flex-col">
              <label htmlFor="ff" className="font-semibold mb-2.5">
                Test Duration (minutes)
              </label>
              <InputField
                id="ff"
                name="subject"
                {...register('testTime')}
                type="number"
                placeholder="enter test duration"
                error={errors.testTime?.message}
              />
            </div>
          </div>

          <footer className="text-center">
            <Button
              loading={isAddSubjectLoading || isUpdateSubjectLoading}
              type="submit"
            >
              Submit
            </Button>
          </footer>
        </div>
      </form>
    </Modal>
  );
};

export default AddSubjectModal;
